import { Tabs, TabsProps } from "antd";
import React from "react";
import VendorDetailsModal from "./VendorDetailsModal";
import BiddingTable from "./Bidding/BiddingTable";

const VendorTabs = () => {
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Vendor Information",
      children: (
        <>
          <VendorDetailsModal />
        </>
      ),
    },
    {
      key: "2",
      label: "Bidding Applied",
      children: (
        <>
          <BiddingTable />
        </>
      ),
    },
  ];
  return (
    <>
      <Tabs defaultActiveKey="1" items={items} />
    </>
  );
};

export default VendorTabs;
